export default "__VITE_ASSET__Zd8jCFsS__"